export default "__VITE_ASSET__D8l$c_98__"